import { c as _c } from "react/compiler-runtime";
import { numberFormatter } from '@/lib/formatter';
import { ReactNode } from 'react';
type CountViewProps = {
  icon: ReactNode;
  count: number;
};
export default function CountView(t0) {
  const $ = _c(9);
  const {
    count,
    icon
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span className="flex size-3">{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== count) {
    t2 = numberFormatter(count);
    $[2] = count;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="text-vive-primary-30 ml-1 flex">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className="flex items-center justify-between">{t1}{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}